import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivilegeRoutes from './priviegeRoutes';
import MainLoader from '../components/loader/mainLoader';
import PATHS from './paths';
import { useAuth } from './authContext';

const Home = lazy(() => import('../pages/home'));
const Help = lazy(() => import('../pages/help'));
const Admin = lazy(() => import('../pages/admin'));
const MediaPage = lazy(() => import('../pages/media'));
const WebCast = lazy(() => import('../pages/webcast'));
const Profile = lazy(() => import('../pages/profile'));
const NotFound = lazy(() => import('../pages/notFound'));
const Layout = lazy(() => import('../components/layout'));
const ContactUs = lazy(() => import('../pages/contactUs'));
const SetNewPasswordPage = lazy(() => import('../pages/home'));
const BibleSeminars = lazy(() => import('../pages/bibleSeminars'));
const BibleSeminarsAdmin = lazy(() => import('../pages/dashboard/bibleSeminarsAdmin/bibleSeminarsAdmin'));
const WhatWeBelieve = lazy(() => import('../pages/whatWeBelieve'));
const WebcastPlayer = lazy(() => import('../pages/webcast/webcastPlayer'));
const EcclesialDocuments = lazy(() => import('../pages/ecclesialDocuments'));
const ManageProfile = lazy(() => import('../pages/profile/manageProfile/manageProfile'));
const Unauthorized = lazy(() => import('../pages/unauthorized/unauthorized'));
const ChangePassword = lazy(() => import('../pages/profile/manageProfile/changePassword'));
const AdminDashboard = lazy(() => import('../pages/dashboard'));
const PublicEvents = lazy(() => import('../pages/dashboard/publicEvents/publicEvents'));
const PublicEventsList = lazy(() => import('../pages/publicEventsUsers'));
const Resources = lazy(() => import('../pages/resources'));
const Syllabus = lazy(() => import('../pages/syllabus'));
const PrivacyPolicy = lazy(() => import ('../pages/privacyPolicy'));
const TermsOfUse = lazy(() => import ('../pages/termsOfUse'));

const Router = () => {
  const { user } = useAuth();
  const isUserProfile = user?.userProfile === 1;

  return (
    <Suspense
      fallback={
        <div className='fullscreen-loader fixed'>
          <MainLoader style={{ height: 250, width: 250 }} />
        </div>
      }
    >
      <Routes>
        {/* Public and Protected Routes Inside a Single Layout */}
        <Route element={<Layout />}>
          {/* Public Routes */}
          <Route path={PATHS.HOME} element={<Home />} />
          <Route path={PATHS.HELP} element={<Help />} />
          <Route path={PATHS.NOT_FOUND} element={<NotFound />} />
          <Route path={PATHS.WEB_CAST_SIGN_IN} element={<WebCast />} />
          <Route path={PATHS.UNAUTHORIZED} element={<Unauthorized />} />
          <Route path={PATHS.WEB_CAST_VIDEO} element={<WebcastPlayer />} />
          <Route path={PATHS.RESET_PASSWORD} element={<SetNewPasswordPage />} />
          <Route path={PATHS.WHAT_WE_BELIEVE} element={<WhatWeBelieve />} />
          <Route path={PATHS.MEDIA} element={<MediaPage />} />
          <Route path={PATHS.BIBLE_SEMINARS} element={<BibleSeminars />} />
          <Route path={PATHS.VIDEO_PLAYER} element={<MediaPage />} />
          <Route path={PATHS.VIDEO_TAB} element={<MediaPage />} />
          <Route path={PATHS.AUDIO_TAB} element={<MediaPage />} />
          <Route path={PATHS.CONTACT_US} element={<ContactUs />} />
          <Route path={PATHS.PRIVACY_POLICY} element={<PrivacyPolicy />} />
          <Route path={PATHS.TERMS_OF_USE} element={<TermsOfUse />} />

          {/* Protected Routes */}
          <Route element={<PrivilegeRoutes />}>
            {isUserProfile ? (
              <>
                <Route path={PATHS.PROFILE} element={<Profile />} />
                <Route path={PATHS.MANAGE_PROFILE} element={<ManageProfile />} />
                <Route path={PATHS.CHANGE_PASSWORD} element={<ChangePassword />} />
              </>
            ) : (
              <Route path='*' element={<Navigate to={PATHS.UNAUTHORIZED} replace />} />
            )}
            <Route path={PATHS.ECCLESIAL_DOCUMENT} element={<EcclesialDocuments />} />
            <Route path={PATHS.SYLLABUS} element={<Syllabus />} />
            <Route path={PATHS.MANAGE_USERS} element={<Admin />} />
            <Route path={PATHS.USERS_TAB} element={<AdminDashboard />} />
            <Route path={PATHS.USAGE_TAB} element={<AdminDashboard />} />
            <Route path={PATHS.ADMINEVENTS} element={<AdminDashboard />} />
            <Route path={PATHS.ADMIN_BIBLE_SEMINARS} element={<AdminDashboard />} />
            <Route path={PATHS.RESOURCES} element={<Resources />} />
            <Route path={PATHS.PUBLIC_EVENTS} element={<PublicEventsList />} />
            <Route path={PATHS.PUBLIC_EVENTS_TAB} element={<PublicEvents />} />
          </Route>
        </Route>
        <Route path='*' element={<Navigate to={PATHS.NOT_FOUND} replace />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
